import { NavLink } from 'react-router';
import type { User } from '@cleartask/shared';
import { useNavItems } from '../navigation.js';
import { ListsPanel } from '../features/lists/ListsPanel.js';
import { TagsPanel } from '../features/tags/TagsPanel.js';
import { Logo } from './Logo.js';

interface SidebarProps {
  user: User;
}

/**
 * Sidebar do desktop (spec 9.6): 240px fixos, some abaixo de 768px.
 *
 * Some mesmo — e por isso a secao de listas vive em `ListsPanel`, montada
 * tambem na aba Mais. Uma funcionalidade que so existe acima de 768px e uma
 * funcionalidade que metade dos acessos nao tem.
 */
export function Sidebar({ user }: SidebarProps) {
  const abas = useNavItems();

  return (
    <aside
      aria-label="Navegação principal"
      className="hidden w-sidebar shrink-0 flex-col gap-6 overflow-y-auto border-r border-border bg-surface px-4 py-5 md:flex"
    >
      <Logo height={26} />

      <div className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className="grid h-8 w-8 place-items-center rounded-full bg-brand-navy text-sm font-semibold text-white"
        >
          {user.displayName.charAt(0).toUpperCase()}
        </span>
        <span className="truncate text-sm font-medium">{user.displayName}</span>
      </div>

      <nav className="flex flex-col gap-1">
        {abas.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) =>
              [
                'flex items-center gap-3 rounded-sm px-3 py-2 text-sm transition-colors duration-150',
                isActive
                  ? 'bg-brand-blue-soft font-medium text-brand-blue'
                  : 'text-text hover:bg-surface-2',
              ].join(' ')
            }
          >
            <span aria-hidden="true">{item.glyph}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <section className="flex flex-col gap-1 border-t border-border pt-4">
        <h2 className="px-3 pb-1 text-xs font-medium uppercase tracking-wide text-text-mut">
          Listas
        </h2>

        <ListsPanel />
      </section>

      <section className="flex flex-col gap-1 border-t border-border pt-4">
        <h2 className="px-3 pb-1 text-xs font-medium uppercase tracking-wide text-text-mut">
          Tags
        </h2>

        <TagsPanel />
      </section>
    </aside>
  );
}
